import { makeAutoObservable } from "mobx";

class Chatstate {
  isOpen: boolean = false;
  
  constructor() {
    makeAutoObservable(this);
  }

  toggle() {
    this.isOpen = !this.isOpen;
  }

  show(state: boolean) {
    this.isOpen = state;
  }

}

export default new Chatstate();
